import Vue from 'vue'

// Root template
import App from './App.vue'

// Vue store
import store from '@/store';

// Application routes
import router from "@/router";

// Router
import VueRouter from "vue-router";

// Loader
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// Bootstrap
import '@/assets/bootstrap-custom.scss';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';


Vue.config.productionTip = false;


// Enable the Vue plugins
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Loading, {
    color: '#024A8C'
});


new Vue({
    render: h => h(App),
    router,
    store,
    beforeCreate: async function () {
        let loader = this.$loading.show();
        await store.dispatch('authenticate');
        store.commit('appLoaded');
        loader.hide();
    }
}).$mount('#app');
